export default __webpack_public_path__ + "media/images/brands/expmessenger/services/service-07-4880fe5a1183a29845829a69d7ee2a99.jpg";